"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.quotePreparation = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _constants = require("../../../constants/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getGenderByTitle = function getGenderByTitle(titleCode) {
  var titleUpperCased = titleCode.toUpperCase();
  if (titleUpperCased === 'MR') {
    return {
      genderId: _constants.MALE_GENDER_ID,
      genderName: _constants.MALE_GENDER
    };
  }
  return {
    genderId: _constants.FEMALE_GENDER_ID,
    genderName: _constants.FEMALE_GENDER
  };
};
var handleClientNumber = function handleClientNumber(hasMemberNumber, memberNumber, clientNumbers, memberNumberFieldSettings) {
  if (hasMemberNumber && memberNumber && clientNumbers && clientNumbers.length && memberNumberFieldSettings && memberNumberFieldSettings.clientNumberTypeCode) {
    var hydratedMemberNumber = clientNumbers.map(function (item) {
      return item.clientNumberTypeCode === (memberNumberFieldSettings === null || memberNumberFieldSettings === void 0 ? void 0 : memberNumberFieldSettings.clientNumberTypeCode) ? _objectSpread(_objectSpread({}, item), {}, {
        number: memberNumber
      }) : item;
    });
    return hydratedMemberNumber;
  }
  if (!clientNumbers) {
    return [];
  }
  return clientNumbers;
};

/**
 * Prepare the data for submission
 * @param {*} ownerDetails
 * @returns
 */
var prepareOwner = function prepareOwner(ownerDetails, hasMemberNumber, memberNumber, ownerMemberNumberInput) {
  var _ownerDetails$titleCo, _handleClientNumber;
  var _getGenderByTitle = getGenderByTitle((_ownerDetails$titleCo = ownerDetails.titleCode) !== null && _ownerDetails$titleCo !== void 0 ? _ownerDetails$titleCo : 'MR'),
    genderId = _getGenderByTitle.genderId,
    genderName = _getGenderByTitle.genderName;
  var postcode = ownerDetails.postcode,
    suburb = ownerDetails.suburb,
    state = ownerDetails.state,
    email = ownerDetails.email,
    dpid = ownerDetails.dpid,
    barcode = ownerDetails.barcode,
    address = ownerDetails.address,
    firstName = ownerDetails.firstName,
    surname = ownerDetails.surname,
    dateofBirth = ownerDetails.dateofBirth,
    telephoneMobile = ownerDetails.telephoneMobile,
    titleName = ownerDetails.titleName,
    titleCode = ownerDetails.titleCode,
    day = ownerDetails.day,
    month = ownerDetails.month,
    year = ownerDetails.year,
    clientNumbers = ownerDetails.clientNumbers,
    marketingConsent = ownerDetails.marketingConsent,
    hasAuthorisePerson = ownerDetails.hasAuthorisePerson,
    authorisedMemberFirstName = ownerDetails.authorisedMemberFirstName,
    authorisedMemberSurname = ownerDetails.authorisedMemberSurname,
    authorisedMemberDob = ownerDetails.authorisedMemberDob,
    isEmailCommunicaton = ownerDetails.isEmailCommunicaton,
    hasInsuranceCancelled = ownerDetails.hasInsuranceCancelled;
  return {
    dpid: dpid,
    barcode: barcode,
    firstName: firstName,
    surname: surname,
    dateofBirth: (0, _helpers.IsValidDate)(dateofBirth) ? (0, _helpers.DateToShortIsoString)(dateofBirth) : null,
    genderId: genderId,
    genderName: genderName,
    postcode: postcode,
    suburb: suburb,
    email: email,
    state: state,
    address: address,
    telephoneMobile: telephoneMobile,
    titleCode: titleCode,
    titleName: titleName,
    day: day,
    month: month,
    year: year,
    hasAuthorisePerson: hasAuthorisePerson,
    authorisedMemberFirstName: authorisedMemberFirstName,
    authorisedMemberSurname: authorisedMemberSurname,
    isEmailCommunicaton: isEmailCommunicaton,
    authorisedMemberDob: authorisedMemberDob,
    hasInsuranceCancelled: hasInsuranceCancelled,
    clientNumbers: (_handleClientNumber = handleClientNumber(hasMemberNumber, memberNumber, clientNumbers, ownerMemberNumberInput)) !== null && _handleClientNumber !== void 0 ? _handleClientNumber : [],
    marketingConsent: marketingConsent
  };
};
var prepareQuote = function prepareQuote(savedQuote, ownerDetails, selectedMediaListCode, vetDetails, externalId, memberNumber, ownerMemberNumberInput) {
  return _objectSpread(_objectSpread(_objectSpread({}, savedQuote), {}, {
    owner: _objectSpread(_objectSpread({}, savedQuote.owner), prepareOwner(ownerDetails, savedQuote === null || savedQuote === void 0 ? void 0 : savedQuote.hasMemberNumber, memberNumber, ownerMemberNumberInput))
  }, vetDetails), {}, {
    hasMediaList: !!savedQuote.selectedMediaListCode,
    externalId: externalId !== null && externalId !== void 0 ? externalId : null,
    memberNumber: savedQuote !== null && savedQuote !== void 0 && savedQuote.hasMemberNumber ? memberNumber : null,
    selectedMediaListCode: selectedMediaListCode
  });
};
var quotePreparation = exports.quotePreparation = {
  prepare: prepareQuote
};